export default "__VITE_ASSET__BKuOr9Qm__"